/**
 * Обработчики событий для переключения темы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-events
 */

(function() {
  'use strict';

  // Флаг для отслеживания привязки делегированного обработчика
  var delegatedHandlerAttached = false;

  /**
   * Обработчик клика на логотип для переключения темы
   */
  function handleThemeToggleClick(e) {
    // Проверяем, что клик был именно по логотипу
    var target = e.target;
    var logoCell = target.closest ? target.closest('#logo-cell') : 
                   (target.id === 'logo-cell' ? target : 
                    (target.parentElement && target.parentElement.id === 'logo-cell' ? target.parentElement : null));
    
    if (logoCell && logoCell.id === 'logo-cell' && logoCell.classList.contains('theme-toggle-logo')) {
      e.preventDefault();
      e.stopPropagation();
      
      // Определяем текущую СОХРАНЕННУЮ тему ДО переключения (не эффективную!)
      // Используем getStoredTheme(), а не getCurrentTheme(), чтобы правильно определить цикл переключения
      var currentStoredTheme = window.THEME_STORAGE.get();
      var nextTheme = window.THEME_DETECTION.getNext(currentStoredTheme);
      
      // Показываем анимацию с иконкой новой темы (и на десктопе тоже, чтобы скрыть hover-эффект)
      if (logoCell) {
        // Показываем иконку новой темы (которая будет после переключения)
        window.THEME_UI.showThemeIconAnimation(logoCell, nextTheme);
      }
      
      window.THEME_TOGGLE.toggle();
      
      return false;
    }
  }

  /**
   * Функция для привязки обработчика к логотипу (может быть вызвана несколько раз)
   * Примечание: Основной обработчик — делегированный (handleThemeToggleClick).
   * Этот прямой обработчик служит резервом и вызывает полную анимацию.
   */
  function attachLogoHandler() {
    var logoCell = document.getElementById('logo-cell');
    if (logoCell && logoCell.classList.contains('theme-toggle-logo')) {
      // Проверяем, не привязан ли уже обработчик
      if (logoCell.hasAttribute('data-theme-handler-attached')) {
        return true; // Уже привязан
      }
      
      logoCell.setAttribute('data-theme-handler-attached', 'true');
      
      logoCell.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Определяем следующую тему и показываем анимацию
        var currentStoredTheme = window.THEME_STORAGE.get();
        var nextTheme = window.THEME_DETECTION.getNext(currentStoredTheme);
        window.THEME_UI.showThemeIconAnimation(logoCell, nextTheme);
        
        window.THEME_TOGGLE.toggle();
      }, false);
      
      return true;
    }
    return false;
  }

  /**
   * Привязать делегированный обработчик событий
   */
  function attachDelegatedHandler() {
    if (!delegatedHandlerAttached) {
      delegatedHandlerAttached = true;
      document.addEventListener('click', handleThemeToggleClick, true);
    }
  }

  // Привязываем делегированный обработчик СРАЗУ (работает даже до загрузки DOM)
  attachDelegatedHandler();

  window.THEME_EVENTS = {
    attachLogoHandler: attachLogoHandler,
    attachDelegatedHandler: attachDelegatedHandler
  };
})();

